/* eslint no-console:0 */
// To reference this file, use <%= vite_javascript_tag 'some-file.js' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// So redux-devtools works nicely. See https://github.com/reduxjs/redux-devtools/issues/1028#issuecomment-1032049854
// eslint-disable-next-line
import Symbol_observable from 'symbol-observable'

// polyfills etc..
import '../src/globals.js'
import '../src/temporal.js'

import Rails from '@rails/ujs'

import { registerAllModules } from '../src/registry.js'

// Standalone modules
import '../src/utils/index.js'
import '../src/timelines.jsx'
import '../src/people.jsx'
import '../src/groups.jsx'
import '../src/notifications.jsx'
import '../src/shared.jsx'
import '../src/classic_timeline_editor.jsx'
import '../src/projects.jsx'
import '../src/dashboard.jsx'
import '../src/views.jsx'

// ui modules for main layouts
import '../src/default-ui.js'
import '../src/app-ui.jsx'

// registry
registerAllModules()

Rails.start()

// We check for the existence of this variable in our DOMContentLoaded handler
// This allows us to make sure that this file has been parsed before attempting to call functions in it
// This is needed because network connection could fail during JS download, causing DOMContentLoaded to fire, but the Timetoast JavaScript not to be available
window.Timetoast.isReady = true
